import { render } from "./CabinetDishCard.vue?vue&type=template&id=e487325c&lang=pug"
import script from "./CabinetDishCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetDishCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__